import React from "react";
import type { InputProps } from "@mui/joy";
import { Input } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import { darkInputUnderlineRootSx } from "../../styles/globalStyles";

/** Dark-themed Joy Input (underline chrome; consumers may override fully via sx). */
const DarkInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { sx, variant = "plain", ...other } = props;

  const mergedSx: SxProps =
    sx == null
      ? darkInputUnderlineRootSx
      : Array.isArray(sx)
        ? [darkInputUnderlineRootSx, ...sx]
        : [darkInputUnderlineRootSx, sx];

  return <Input ref={ref} variant={variant} sx={mergedSx} {...other} />;
});

DarkInput.displayName = "DarkInput";

export default DarkInput;
